/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-22 17:11:59
 * @LastEditors: pingping.mao
 * @LastEditTime: 2022-12-19 15:46:18
 */
const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userInfo: state => state.user.userInfo,
  company: state => state.user.company,
  authorityList: state => state.user.authorityList,
  roleListInfo: state => state.user.roleListInfo,
  appList: state => state.user.appList,
  isTenant: state => state.user.isTenant,
  tenantId: state => state.user.tenantId,
  userId: state => state.user.userId,
  useOrgId: state => state.user.useOrgId,
  orgId: state => state.user.orgId,
  orgName: state => state.user.company,
  infoData: state => state.user.infoData,
  roles: state => state.user.roles,
  isSystem: state => state.user.isSystem,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  title: state => state.user.title,
  // permission_routes: (state) => state.permission.routes,
  size: state => state.app.size,
  routerInfo: state => state.permission.routerInfo,
  permissions: state => state.user.permissions,
  mircAppDic: state => state.user.mircAppDic,
  routes: state => state.permission.routes,
  orgnaization: state => state.energy.orgnaization,
  currentNode: state => state.energy.currentNode,
  energyItem: state => state.energy.energyItem,
  addRouters: state => state.permission.addRouters,
  showFullLoading: state => state.loading.showFullLoading,
  menuTabs: state => state.menuTabs.menuTabs,
  menuActived: state => state.menuTabs.menuActived,
  isRefresh: state => state.cacheViews.isRefresh,
  currentTag: state => state.tagsView.currentTag,
  openAttachmentNotify: state => state.settings.openAttachmentNotify,
  tenantData: state => state.user.tenantData
};
export default getters;
